import callApi from "../../api/axios";

export const getTrackingLinks = ({ limit, offset }) => {
  return callApi({
    method: "GET",
    url: `tracking-links?limit=${limit}&offset=${offset}`,
  });
};

export const getTrackingLinksById = (id) => {
  return callApi({ method: "GET", url: `tracking-links/${id}` });
};

export const createTrackingLinks = (values) => {
  return callApi({ method: "POST", url: `tracking-links`, data: values });
};

export const removeTrackingLink = (payload) => {
  return callApi({
    method: "DELETE",
    url: `tracking-links/${payload._id}`,
    data: payload,
  });
};

export const updateTrackingLink = (payload) => {
  return callApi({
    method: "PUT",
    url: `tracking-links/${payload._id}`,
    data: payload,
  });
};

export const searchUser = (value) => {
  return callApi({ method: "POST", url: `users/search`, data: { q: value } });
};
